import { client, getErrorMessage } from "./client.ts";
import { BASE_URL } from "./client.ts";

const base_url = "/ai";

export const startTrain = async ({
  id,
  uuid,
  dataset_path,
  auto_valid,
  ip,
  epoch,
  saveOption,
  parentModel, //이어학습 진행 시
  trainCount,
  isMulti,
}) => {
  try {
    const response = await client.post(`${base_url}/training/start`, {
      train_id: id,
      uuid,
      dataset_path,
      auto_valid,
      ip,
      epoch,
      saveOption,
      parentModel,
      trainCount,
      isMulti,
    });
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
